import { checkHasAnyRoleOrPermission } from 'constants/permission';
import { useSelector } from 'react-redux';

const AccessControl = ({ permissions, roles, children }) => {
  const { permissions: permissionsList, roles: roleList } = useSelector(
    (state) => state.auth
  );
  return checkHasAnyRoleOrPermission(
    permissionsList,
    roleList,
    roles,
    permissions
  )
    ? children
    : null;
};

export default AccessControl;